export const ADDRESS_ICONS = {
  imgByke: '684KQo1Il6Mgj0Cj4SwFRd',
  imgStore: '4Hsg5W7ayBDrMB1pLNzjwP'
}
